<!-- CONTENIDO PARA MODAL VALOR RESIDUAL -->
<div class="modal">
  <a class="close" (click)="close()">Cerrar</a>
  <h1>Agregar valor residual</h1>

  <div class="valorResidual">
    <form [formGroup]="form" (ngSubmit)="saved()">
      <div class="wrapper">
        <div class="controlWrapper">
          <label for="">Plazo <span class="required">*</span></label>
          <div class="selectWrapper">
            <div class="inputAndUnit">
              <div class="customWrapper">
                <div class="inputAndUnit">
                  <input type="number" formControlName="term" (blur)="handleTermChange()" />
                </div>
              </div>
              <span>Meses</span>
            </div>
          </div>
          @if(isTermUsedSig()){
            <span class="error">El plazo ya se encuentra en uso.</span>
          }
          @if(form.controls['term'].errors?.['min']){
            <span class="error">El plazo debe ser mayor a {{ minTerm }}.</span>
          }
          @if(form.controls['term'].errors?.['max']){
            <span class="error">El plazo debe ser menor a {{ maxTerm }}.</span>
          }
        </div>

        <div class="controlWrapper">
          <label>Garantía Daimler<span class="required">*</span></label>
          <div class="rateAndMax">
            <div class="inputAndUnit">
              <input type="number" formControlName="daimlerRate" (blur)="handleDaimlerRate()" />
              <span>%</span>
            </div>
            <div class="inputAndUnit residualValue">
              <input
                type="number"
                id="daimlerFixedAmount"
                style="display: none"
                (blur)="handleFixedAmount()"
                formControlName="daimlerFixedAmount"
                (keypress)="preventInvalidCharacters($event)"
              />
              <input
                type="text"
                id="hidden-daimlerFixedAmount"
                (focus)="showAmountInput('daimlerFixedAmount')"
                style="display: block"
                [value]="form.controls['daimlerFixedAmount'].value | currency : '' : ''"
              />
              <span>MXN</span>
            </div>
          </div>
        </div>

        <div class="controlWrapper">
          <label>Garantía Terceros<span class="required">*</span></label>
          <div class="terceros">
            <div class="inputAndUnit">
              <input type="number" formControlName="externalsMinRate" (blur)="handleExternalsMinRate()" />
              <span>%</span>
              <span class="min">Min</span>
            </div>
            <div class="inputAndUnit">
              <input type="number" formControlName="externalsMaxRate" (blur)="handleExternalsMinRate()" />
              <span>%</span>
              <span class="max">Max</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Acciones para modal condición -->
      <div class="actions">
        <button type="button" class="secondary" (click)="close()">Cancelar</button>
        <button type="submit" class="primary" [disabled]="form.invalid || isTermUsedSig()" (click)="saved()">
          Aceptar
        </button>
      </div>
    </form>
  </div>
</div>
